import { AuthManager } from "utils/AuthManager"

// Professor portal only: the Documents tab is limited to these accounts. EQA always has it
const DOCUMENTS_ALLOWED_EMAILS = [
  "db@suraasa.com",
  "db@lestransformations.com",
  "prithvi.gulati@suraasa.com",
  "ansh@suraasa.com",
  "agh@suraasa.com",
  "dareen@suraasa.com",
]

/** Read from the saved login so it's correct on the first render, before the profile loads */
export const canAccessDocuments = (): boolean =>
  import.meta.env.VITE_EQA_ONLY_MODE === "true" ||
  DOCUMENTS_ALLOWED_EMAILS.includes(
    AuthManager.getAuthInfo()?.user.email.toLowerCase() ?? ""
  )
